"use strict";

angular.module('app.modals.loading', [])

    .controller('loadingModalCtrl', ['$scope', '$state','close',
        function ($scope, $state,close) {
            $scope.dismissModal = function(){
                try {
                    close(50);
                }catch(err) {

                }
            }

        }
    ])

    .factory('loadingModal', ['ModalService', '$q', function (ModalService, $q) {
        return function (loadingText) {

            return ModalService.showModal({
                templateUrl: "views/modals/loading.html",
                controller: 'loadingModalCtrl',
                inputs: {
                    loadingText: loadingText
                }
            });


        }
    }]);